import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

/**
 * Reusable loading backdrop component
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether backdrop is open
 * @param {string} props.message - Loading message to display
 * @returns {JSX.Element} LoadingBackdrop component
 */
const LoadingBackdrop = ({ open, message = "Loading data, please wait..." }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
      }}
      open={open}
    >
      <img 
        src="/images/AIMethods_logo.png" 
        alt="Logo" 
        style={{ width: 500, marginBottom: 16 }} 
      />
      <CircularProgress color="inherit" />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        {message}
      </Typography>
    </Backdrop>
  );
};

export default LoadingBackdrop;
